module.exports = __webpack_public_path__ + "media/video-background-mobile.4b06ef6f.mp4";